<div class="input-otp">
  <input
    *ngFor="let val of otpValues; let i = index; trackBy: trackByIndex"
    [id]="inputId(i)"
    type="text"
    inputmode="numeric"
    maxlength="1"
    class="otp-input"
    placeholder="-"
    [ngClass]="{ 'otp-input-error': invalid }"
    (input)="onOtpInput($event, i)"
    (keydown)="onOtpKeyDown($event, i)"
  />
</div>

<div *ngIf="invalid && errorMessage" class="text-danger text-center mt-1 mb-1">
  {{ errorMessage }}
</div>